export default __webpack_public_path__ + "static/media/dot.f5fbf006.svg";